import React from "react";
import { Box } from "@mui/material";

/** width×height pixel — larger icon for better readability */
const SIZE_PX = {
    xs: { w: 40, h: 26 },
    small: { w: 56, h: 36 },
    medium: { w: 72, h: 44 },
    large: { w: 92, h: 52 },
};

/**
 * @param {'visa'|'mastercard'|'amex'|'troy'|'discover'} props.brand
 * @param {'xs'|'small'|'medium'|'large'} [props.size='medium']
 */
function CardBrandIcon({ brand, size = "medium" }) {
    if (!brand) {
        return null;
    }
    const { w, h } = SIZE_PX[size] || SIZE_PX.medium;

    const svgs = {
        visa: (
            <svg width={w} height={h} viewBox="0 0 96 32" preserveAspectRatio="xMidYMid meet" aria-hidden focusable="false">
                <rect width="96" height="32" rx="4" fill="#1434CB" />
                <text x="48" y="22" textAnchor="middle" fill="white" fontSize="15" fontWeight="700" fontFamily="system-ui,Arial,sans-serif">
                    VISA
                </text>
            </svg>
        ),
        mastercard: (
            <svg width={w} height={h} viewBox="0 0 96 32" preserveAspectRatio="xMidYMid meet" aria-hidden focusable="false">
                <rect width="96" height="32" rx="4" fill="#f5f5f5" />
                <circle cx="40" cy="16" r="12" fill="#EB001B" />
                <circle cx="56" cy="16" r="12" fill="#F79E1B" fillOpacity="0.95" />
                <path d="M48 8.5c2.6 1.9 4.2 5 4.2 7.5s-1.6 5.6-4.2 7.5c-2.6-1.9-4.2-5-4.2-7.5s1.6-5.6 4.2-7.5z" fill="#FF5F00" />
            </svg>
        ),
        amex: (
            <svg width={w} height={h} viewBox="0 0 96 32" preserveAspectRatio="xMidYMid meet" aria-hidden focusable="false">
                <rect width="96" height="32" rx="4" fill="#006FCF" />
                <text x="48" y="21" textAnchor="middle" fill="white" fontSize="12" fontWeight="700" fontFamily="system-ui,Arial,sans-serif">
                    AMEX
                </text>
            </svg>
        ),
        troy: (
            <svg width={w} height={h} viewBox="0 0 96 32" preserveAspectRatio="xMidYMid meet" aria-hidden focusable="false">
                <rect width="96" height="32" rx="4" fill="#005BAC" />
                <text x="48" y="21" textAnchor="middle" fill="white" fontSize="13" fontWeight="700" fontFamily="system-ui,Arial,sans-serif">
                    TROY
                </text>
            </svg>
        ),
        discover: (
            <svg width={w} height={h} viewBox="0 0 112 32" preserveAspectRatio="xMidYMid meet" aria-hidden focusable="false">
                <rect width="112" height="32" rx="4" fill="#FF6000" />
                <text x="56" y="21" textAnchor="middle" fill="white" fontSize="11" fontWeight="700" fontFamily="system-ui,Arial,sans-serif">
                    DISCOVER
                </text>
            </svg>
        ),
    };

    const node = svgs[brand];
    if (!node) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                lineHeight: 0,
                maxHeight: h,
            }}
            aria-hidden
        >
            {node}
        </Box>
    );
}

export default CardBrandIcon;
